import { connect } from "react-redux";
import PremierDeliveryNotice from "../../components/PremierDeliveryNotice/index.jsx";

const mapStateToProps = (state, { appConfig }) => ({
  countriesData: state.PremierSelectorOptions.countriesData,
  premierDeliveryNotice: state.PremierPageFrame.content.premierDeliveryNotice,
  premierHighReturnerMessage:
    state.PremierPageFrame.content.premierHighReturnerMessage,
  assetsUrl: state.Environment.assetsUrl,
  appConfig,
});

export default connect(mapStateToProps)(PremierDeliveryNotice);
